import { loadStateData } from './../Storage';

/* eslint-disable no-undef */

const getToken = () => {
  const storeSate = loadStateData();
  if (!storeSate) return false;
  const { user: { accessToken, access_token } = false } = storeSate;
  return storeSate.user && (accessToken || access_token);
};

const getAuthExpiration = () => {
  const stateData = loadStateData() || {};
  const { user: { authExpiration = null } = {} } = stateData || {};
  const nextAuthExpiration = (authExpiration && authExpiration * 1000) || Date.now();

  return nextAuthExpiration;
};

const Auth = {
  isUserAuthenticated: () => getToken() && (Date.now()) <= getAuthExpiration(),
  getToken,
  getAuthExpiration,
  getUser: () => {
    const stateData = loadStateData() || {};

    return stateData.user || null;
  },
  logout: () =>
    localStorage.clear(),
  getTokenLifeTime: () => {
    const differenceSeconds = String(getAuthExpiration()).substr(0, 10) - String(Date.now()).substr(0, 10);

    return differenceSeconds > 0 ? differenceSeconds : 0;
  }
};

export default Auth;
